import Apiservice from '../../api.service';
import { API_URL } from '../../../../common/config.js'
const apiService = Apiservice;


export default class GatePassService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/kiosk/gate-pass`;
    }
    
    search(data={}) {
        let url = `${this.#api}/search`;
        
        let param ={
            params: data
        }

        return apiService.query(url,param);
    }

    markAsUsed(id){
        let url = `${this.#api}/${id}/mark-as-used`
        return apiService.post(url);
    }

    print(gatePassId){
        let url = `${this.#api}/${gatePassId}/print`
        window.open(url, '_blank');
    }
}